module.exports = __webpack_public_path__ + "static/img/s506.098a9b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s506.png
// module id = 568
// module chunks = 3